import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer token if available (fallback when cookies are blocked cross-origin)
api.interceptors.request.use((config) => {
  const t = typeof window !== "undefined" ? localStorage.getItem("triplus_token") : null;
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

// Global handling: a deactivated account (revoked live session) gets 403
// "Account is deactivated" on any protected request. Clear the local session and
// bounce to login with a clean message. Guarded against redirect loops.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const detail = err?.response?.data?.detail;
    if (err?.response?.status === 403 && detail === "Account is deactivated") {
      if (typeof window !== "undefined") {
        localStorage.removeItem("triplus_token");
        if (!window.location.pathname.startsWith("/login")) {
          window.location.assign("/login?deactivated=1");
        }
      }
    }
    return Promise.reject(err);
  }
);

export const COLLECTIONS = {
  opportunities: { label: "Opportunities", path: "/opportunities" },
  candidate_opportunities: { label: "Candidate Opportunities", path: "/candidates" },
  search_rules: { label: "Search Rules", path: "/search-rules" },
  search_runs: { label: "Search Runs", path: "/search-runs" },
  search_intelligence: { label: "Search Intelligence", path: "/search-intelligence" },
  tasks: { label: "Tasks", path: "/tasks" },
  documents: { label: "Documents", path: "/documents" },
  buyers: { label: "Buyers", path: "/buyers" },
  requirements: { label: "Requirements", path: "/requirements" },
  awards: { label: "Awards", path: "/awards" },
  suppliers: { label: "Suppliers", path: "/suppliers" },
  opportunity_suppliers: { label: "Supplier Assignments", path: "/supplier-assignments" },
  supplier_samples: { label: "Supplier Samples", path: "/supplier-samples" },
  supplier_deliverables: { label: "Supplier Deliverables", path: "/supplier-deliverables" },
  supplier_production: { label: "Supplier Production", path: "/supplier-production" },
  supplier_questions: { label: "Supplier Questions", path: "/supplier-questions" },
};
